import React from "react";
import GetText from "../../i18n/GetText";
import { Level } from "../../model/common";
import { useIsRtl } from "../../utils/LayoutContext";
import { levelToNumber } from "../../utils/level-util";

const LevelImage = ({
  style,
  value
}: {
  style?: React.CSSProperties;
  value: Level;
}) => {
  const level = levelToNumber(value);
  const color = "#999999";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="16"
      viewBox="0 0 25 16"
      style={style}
    >
      <g
        fill="none"
        fillRule="nonzero"
        stroke="#999999"
        transform="translate(1 1)"
      >
        <rect
          width="5"
          height="14"
          x="18"
          rx="1"
          fill={level >= 2 ? color : undefined}
        />
        <rect
          width="5"
          height="10"
          x="9"
          y="4"
          rx="1"
          fill={level >= 1 ? color : undefined}
        />
        <rect
          width="5"
          height="6"
          y="8"
          fill={level >= 0 ? color : undefined}
          rx="1"
        />
      </g>
    </svg>
  );
};

// Do not add typography here, the caller should determine the typography.
const LevelIndicator = ({ value }: { value: Level }) => {
  const isRtl = useIsRtl();
  return (
    <span style={{ display: "inline-block" }}>
      <LevelImage
        value={value}
        style={{
          marginInlineEnd: "10px",
          transform: `scaleX(${isRtl ? -1 : 1})`
        }}
      />
      <GetText id={value} />
    </span>
  );
};

export default LevelIndicator;
